/**
 * Converte una stringa data in formato YYYY-MM-DD.
 * Formati accettati: DDMMYYYY, D/M/YYYY, DD.MM.YYYY, DD-MM-YYYY, YYYY-MM-DD.
 * Ritorna null se non riconosciuto o non valido.
 *
 * Duplicato intenzionale di logic/helpers/date.ts (il client non puo' importare da logic/).
 */
export function parseDataNascita(input: string): string | null {
  const s = input.trim();
  let gg: string, mm: string, aaaa: string;

  if (/^\d{8}$/.test(s)) {
    gg = s.slice(0, 2);
    mm = s.slice(2, 4);
    aaaa = s.slice(4, 8);
  } else {
    const sep = s.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/);
    if (sep) {
      gg = sep[1]!.padStart(2, '0');
      mm = sep[2]!.padStart(2, '0');
      aaaa = sep[3]!;
    } else {
      const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso) {
        aaaa = iso[1]!;
        mm = iso[2]!;
        gg = iso[3]!;
      } else {
        return null;
      }
    }
  }

  const g = Number(gg);
  const m = Number(mm);
  if (g < 1 || g > 31 || m < 1 || m > 12) return null;

  return `${aaaa}-${mm}-${gg}`;
}
